/* NB theme layer — lightweight behaviours for nb-* sections. No dependencies. */
(() => {
  document.documentElement.classList.add('nb-js');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || (window.NB && NB.moneyFormat) || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    const fmt = (n, d, ts = ',', ds = '.') => {
      const [i, f] = (n / 100).toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fmt(cents, 2), amount_no_decimals: fmt(cents, 0),
      amount_with_comma_separator: fmt(cents, 2, '.', ','), amount_no_decimals_with_comma_separator: fmt(cents, 0, '.', ','),
      amount_with_apostrophe_separator: fmt(cents, 2, "'", '.'), amount_with_space_separator: fmt(cents, 2, ' ', ','),
    }[k] ?? fmt(cents, 2)));
  }

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' })
    : null;
  function initReveal(root) {
    $$('[data-nb-reveal]', root).forEach((el) => (io && !reduce ? io.observe(el) : el.classList.add('is-in')));
  }

  /* ---------- Countdown (announcement + stock timer) ---------- */
  const clocks = new Set();
  function endFor(el) {
    const mode = el.dataset.mode || 'daily';
    if (mode === 'date' && el.dataset.end) {
      const t = Date.parse(el.dataset.end.replace(' ', 'T'));
      if (!isNaN(t)) return t;
    }
    const d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime();
  }
  function tick() {
    const now = Date.now();
    clocks.forEach((el) => {
      if (!el.isConnected) { clocks.delete(el); return; }
      let s = Math.max(0, Math.floor((endFor(el) - now) / 1000));
      if (s === 0 && el.dataset.mode === 'date' && el.dataset.hideOnEnd === 'true') { (el.closest('[data-nb-hide-on-end]') || el).hidden = true; }
      const d = Math.floor(s / 86400), m = Math.floor((s % 3600) / 60), sec = s % 60;
      const D = $('[data-d]', el), H = $('[data-h]', el), M = $('[data-m]', el), S = $('[data-s]', el), T = $('[data-t]', el);
      const h = D ? Math.floor((s % 86400) / 3600) : Math.floor(s / 3600);
      if (D) { D.textContent = pad(d); D.parentElement.style.display = d > 0 ? '' : 'none'; }
      if (H) H.textContent = pad(h); if (M) M.textContent = pad(m); if (S) S.textContent = pad(sec);
      if (T) T.textContent = d > 0 ? `${d}d ${pad(Math.floor((s % 86400) / 3600))}:${pad(m)}:${pad(sec)}` : `${pad(h)}:${pad(m)}:${pad(sec)}`;
    });
  }
  setInterval(tick, 1000);
  function initCountdowns(root) { $$('[data-nb-countdown]', root).forEach((el) => clocks.add(el)); tick(); }

  /* ---------- Exclusive accordions ---------- */
  function initAccordions(root) {
    $$('[data-nb-exclusive]', root).forEach((list) => {
      if (list.__nb) return; list.__nb = 1;
      list.addEventListener('toggle', (e) => {
        if (e.target.tagName !== 'DETAILS' || !e.target.open) return;
        $$('details[open]', list).forEach((d) => d !== e.target && (d.open = false));
      }, true);
    });
  }

  /* ---------- Generic rotator (proof ticker, testimonials) ---------- */
  function initRotators(root) {
    $$('[data-nb-rotator]', root).forEach((wrap) => {
      if (wrap.__nb) return; wrap.__nb = 1;
      const items = $$('[data-nb-slide]', wrap), dots = $$('[data-nb-dot]', wrap);
      if (items.length < 2) return;
      let i = Math.max(0, items.findIndex((x) => x.classList.contains('is-active'))), timer;
      const go = (n) => {
        i = (n + items.length) % items.length;
        items.forEach((x, k) => x.classList.toggle('is-active', k === i));
        dots.forEach((x, k) => { x.classList.toggle('is-active', k === i); x.setAttribute('aria-pressed', k === i); });
      };
      const delay = (+wrap.dataset.nbRotator || 5) * 1000;
      const play = () => { clearInterval(timer); if (!reduce && delay > 0) timer = setInterval(() => go(i + 1), delay); };
      dots.forEach((d, k) => d.addEventListener('click', () => { go(k); play(); }));
      wrap.addEventListener('mouseenter', () => clearInterval(timer));
      wrap.addEventListener('mouseleave', play);
      go(i); play();
    });
  }

  /* ---------- Reviews: filters + load more ---------- */
  function initReviews(root) {
    $$('[data-nb-reviews]', root).forEach((sec) => {
      if (sec.__nb) return; sec.__nb = 1;
      const cards = $$('.nb-review', sec), more = $('.nb-reviews__more', sec);
      const per = +sec.dataset.perPage || 9;
      let tag = 'all', shown = per;
      const render = () => {
        const list = cards.filter((c) => tag === 'all' || (c.dataset.tags || '').split(',').includes(tag));
        cards.forEach((c) => { c.hidden = true; c.classList.remove('is-paged'); });
        list.forEach((c, k) => { if (k < shown) c.hidden = false; else c.classList.add('is-paged'); });
        // mobile shows every card in the horizontal scroller
        if (window.matchMedia('(max-width: 749px)').matches) list.forEach((c) => (c.hidden = false));
        if (more) more.hidden = list.length <= shown;
      };
      $$('[data-tag]', sec).forEach((b) => b.addEventListener('click', () => {
        tag = b.dataset.tag; shown = per;
        $$('[data-tag]', sec).forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b); });
        render();
      }));
      more && more.addEventListener('click', () => { shown += per; render(); });
      window.matchMedia('(max-width: 749px)').addEventListener?.('change', render);
      render();
    });
  }

  /* ---------- Before / after ---------- */
  function initBA(root) {
    $$('.nb-ba__media', root).forEach((m) => {
      const r = $('.nb-ba__range', m); if (!r || r.__nb) return; r.__nb = 1;
      const set = () => m.style.setProperty('--pos', r.value + '%');
      r.addEventListener('input', set); set();
    });
  }

  /* ---------- Video stories coverflow ---------- */
  function initStories(root) {
    $$('[data-nb-stories]', root).forEach((sec) => {
      if (sec.__nb) return; sec.__nb = 1;
      const cards = $$('.nb-story', sec); if (!cards.length) return;
      let i = 0;
      const n = cards.length;
      const layout = () => cards.forEach((c, k) => {
        let d = k - i; if (d > n / 2) d -= n; if (d < -n / 2) d += n;
        c.dataset.pos = Math.abs(d) <= 1 ? String(d) : 'hidden';
        c.setAttribute('aria-hidden', d !== 0);
        if (d !== 0) { const v = $('video', c); if (v && !v.paused) { v.pause(); c.classList.remove('is-playing'); } }
      });
      const go = (k) => { i = (k + n) % n; layout(); };
      $('[data-prev]', sec)?.addEventListener('click', () => go(i - 1));
      $('[data-next]', sec)?.addEventListener('click', () => go(i + 1));
      cards.forEach((c, k) => {
        c.addEventListener('click', (e) => { if (c.dataset.pos !== '0') { e.preventDefault(); go(k); } });
        const v = $('video', c), p = $('.nb-story__play', c);
        if (v && p) {
          const toggle = () => { if (c.dataset.pos !== '0') return; if (v.paused) { v.muted = false; v.play(); c.classList.add('is-playing'); } else { v.pause(); c.classList.remove('is-playing'); } };
          p.addEventListener('click', toggle); v.addEventListener('click', toggle);
          v.addEventListener('ended', () => c.classList.remove('is-playing'));
        }
      });
      let x0 = null;
      const track = $('.nb-stories__track', sec);
      track.addEventListener('pointerdown', (e) => (x0 = e.clientX));
      track.addEventListener('pointerup', (e) => { if (x0 === null) return; const dx = e.clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
      layout();
    });
  }

  /* ---------- Autoplay muted videos only while visible ---------- */
  const vio = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
    const v = e.target; if (e.isIntersecting) { v.play().catch(() => {}); } else { v.pause(); }
  }), { threshold: .25 }) : null;
  function initAutoVideos(root) { $$('[data-nb-autoplay] video', root).forEach((v) => (vio && !reduce ? vio.observe(v) : null)); }

  /* ---------- Product: gallery ---------- */
  function initGallery(root) {
    $$('[data-nb-gallery]', root).forEach((g) => {
      if (g.__nb) return; g.__nb = 1;
      const main = $('.nb-gallery__main', g), slides = $$('.nb-gallery__slide', g), thumbs = $$('.nb-gallery__thumb', g);
      const setActive = (k) => thumbs.forEach((t, j) => { t.classList.toggle('is-active', j === k); t.setAttribute('aria-current', j === k); if (j === k) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); });
      const goTo = (k) => { const s = slides[k]; if (!s) return; main.scrollTo({ left: s.offsetLeft - main.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); setActive(k); };
      g.nbGoToMedia = (mediaId) => { const k = slides.findIndex((s) => s.dataset.mediaId === String(mediaId)); if (k > -1) goTo(k); };
      thumbs.forEach((t, k) => t.addEventListener('click', () => goTo(k)));
      let raf;
      main.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const k = Math.round(main.scrollLeft / main.clientWidth);
          setActive(k);
          slides.forEach((s, j) => { if (j !== k) $$('video', s).forEach((v) => v.pause()); });
        });
      }, { passive: true });
      const lb = $('.nb-lightbox', g);
      if (lb) {
        const img = $('img', lb);
        $$('.nb-gallery__slide--zoom', g).forEach((s) => s.addEventListener('click', () => { img.src = s.dataset.zoom; lb.hidden = false; document.body.style.overflow = 'hidden'; }));
        const close = () => { lb.hidden = true; document.body.style.overflow = ''; };
        lb.addEventListener('click', close);
        document.addEventListener('keydown', (e) => e.key === 'Escape' && !lb.hidden && close());
      }
    });
  }

  /* ---------- Product: variants + bundles + gifts ---------- */
  function initProduct(root) {
    $$('[data-nb-product]', root).forEach((sec) => {
      if (sec.__nb) return; sec.__nb = 1;
      const data = JSON.parse($('[data-nb-variants]', sec)?.textContent || '[]');
      const idInputs = () => $$('form[data-type="add-to-cart-form"] input[name="id"]', sec);
      const qtyInputs = () => $$('form[data-type="add-to-cart-form"] input[name="quantity"]', sec);
      let variant = data.find((v) => String(v.id) === String(sec.dataset.variantId)) || data[0];
      if (!variant) return;
      const fmt = sec.dataset.moneyFormat;

      const bars = $$('.nb-bar', sec);
      const tierQty = () => { const c = $('.nb-bar input:checked', sec); return c ? +c.value : 1; };
      const tierIndex = () => { const c = $('.nb-bar input:checked', sec); return c ? +c.dataset.tier : 1; };

      const paint = () => {
        // bundles pricing
        bars.forEach((b) => {
          const q = +b.dataset.qty, pct = +b.dataset.pct || 0;
          const unitCompare = variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
          const price = Math.round(variant.price * q * (100 - pct) / 100), compare = unitCompare * q;
          const P = $('.nb-bar__price', b), C = $('.nb-bar__compare', b), L = $('.nb-bar__label[data-save]', b);
          if (P) P.textContent = formatMoney(price, fmt);
          if (C) { C.textContent = compare > price ? formatMoney(compare, fmt) : ''; }
          if (L) { const save = compare - price; L.hidden = save <= 0; L.textContent = (L.dataset.save || '').replace('[amount]', formatMoney(save, fmt)); }
          b.classList.toggle('is-active', $('input', b).checked);
        });
        // simple price block
        $$('[data-nb-price]', sec).forEach((p) => {
          const b = $('b', p), s = $('s', p);
          if (b) b.textContent = formatMoney(variant.price, fmt);
          if (s) { const show = variant.compare_at_price > variant.price; s.textContent = show ? formatMoney(variant.compare_at_price, fmt) : ''; }
        });
        // gifts
        const t = tierIndex();
        $$('.nb-gift', sec).forEach((g) => g.classList.toggle('is-unlocked', t >= (+g.dataset.unlock || 1)));
        // form
        idInputs().forEach((i) => (i.value = variant.id));
        qtyInputs().forEach((i) => (i.value = tierQty()));
        $$('.nb-buy__btn', sec).forEach((btn) => {
          const span = $('span', btn);
          if (variant.available) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled'); if (span) span.textContent = btn.dataset.label; }
          else { btn.setAttribute('disabled', 'disabled'); if (span) span.textContent = btn.dataset.soldout; }
        });
      };

      // variant pills
      const pickers = $$('[data-nb-option]', sec);
      const selected = () => pickers.map((p) => $('.is-active', p)?.dataset.value);
      const markAvailability = () => {
        const cur = selected();
        pickers.forEach((p, idx) => $$('[data-value]', p).forEach((btn) => {
          const opts = cur.slice(); opts[idx] = btn.dataset.value;
          const v = data.find((x) => x.options.every((o, j) => o === opts[j]));
          btn.classList.toggle('is-unavailable', !v || !v.available);
        }));
      };
      pickers.forEach((p) => $$('[data-value]', p).forEach((btn) => btn.addEventListener('click', () => {
        $$('[data-value]', p).forEach((x) => { x.classList.toggle('is-active', x === btn); x.setAttribute('aria-pressed', x === btn); });
        const cur = selected();
        const v = data.find((x) => x.options.every((o, j) => o === cur[j]));
        const label = $('[data-nb-option-value]', p.closest('.nb-variants__group')); if (label) label.textContent = btn.dataset.value;
        if (v) {
          variant = v;
          if (v.featured_media) $('[data-nb-gallery]', sec)?.nbGoToMedia?.(v.featured_media.id);
          const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        } else {
          variant = { ...variant, available: false };
        }
        markAvailability(); paint();
      })));

      bars.forEach((b) => $('input', b).addEventListener('change', paint));
      markAvailability(); paint();
    });
  }

  /* ---------- Cart drawer: free-shipping bar + upsell (config from NB · Brand design) ---------- */
  let cfg = null;
  try { cfg = JSON.parse(document.getElementById('nb-config')?.textContent || 'null'); } catch (e) {}
  if (cfg) (window.NB = window.NB || {}).moneyFormat = cfg.moneyFormat;
  const el = (tag, cls, txt) => { const n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; };
  let decorating = false;
  async function decorateDrawer() {
    const drawer = document.querySelector('cart-drawer'); if (!cfg || !drawer || decorating) return;
    const inner = $('.drawer__inner', drawer); if (!inner || inner.querySelector('.drawer__inner-empty')) return;
    decorating = true;
    try {
      const cart = await fetch((window.routes?.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      $$('.nb-ship, .nb-upsell', inner).forEach((n) => n.remove());
      if (cart.item_count > 0 && cfg.ship?.on) {
        const rate = +(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
        const t = Math.round((+cfg.ship.threshold || 0) * rate), total = cart.total_price, rem = t - total;
        const pct = t > 0 ? Math.min(100, Math.round((total * 100) / t)) : 100;
        const box = el('div', 'nb-ship'), label = el('p', 'nb-ship__label');
        if (rem > 0) {
          const [pre, post = ''] = (cfg.ship.text || '').split('[amount]');
          label.append(pre, el('strong', null, formatMoney(rem, cfg.moneyFormat)), post);
        } else label.textContent = cfg.ship.done || '';
        const bar = el('div', 'nb-ship__bar'), fill = el('div', 'nb-ship__fill');
        bar.setAttribute('role', 'progressbar'); bar.setAttribute('aria-valuemin', 0); bar.setAttribute('aria-valuemax', 100); bar.setAttribute('aria-valuenow', pct);
        fill.style.setProperty('--p', pct + '%'); bar.append(fill); box.append(label, bar);
        $('.drawer__header', inner)?.after(box);
      }
      const u = cfg.upsell;
      if (u && cart.item_count > 0 && !cart.items.some((i) => i.product_id === u.productId)) {
        const card = el('div', 'nb-upsell');
        if (u.image) { const img = el('img', 'nb-upsell__img'); img.src = u.image; img.alt = u.title; img.loading = 'lazy'; card.append(img); } else card.append(el('span', 'nb-upsell__img'));
        const info = el('div'); info.append(el('p', 'nb-upsell__t', u.heading), el('p', 'nb-upsell__n', u.title));
        const price = el('p', 'nb-upsell__p', u.price + ' '); if (u.compare) price.append(el('s', null, u.compare)); info.append(price);
        const btn = el('button', 'nb-upsell__btn', u.button); btn.type = 'button'; btn.dataset.nbUpsell = u.variantId;
        card.append(info, btn);
        $('.drawer__footer', inner)?.before(card);
      }
    } catch (e) { console.warn('[NB] cart drawer', e); }
    decorating = false;
  }
  let dTimer;
  const queueDecorate = () => { clearTimeout(dTimer); dTimer = setTimeout(decorateDrawer, 60); };
  function watchDrawer() {
    const drawer = document.querySelector('cart-drawer'); if (!drawer || drawer.__nbObs) return;
    drawer.__nbObs = new MutationObserver((muts) => { if (muts.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && !n.matches?.('.nb-ship, .nb-upsell')))) queueDecorate(); });
    drawer.__nbObs.observe(drawer, { childList: true, subtree: true });
    queueDecorate();
  }
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-nb-upsell]'); if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    try {
      const drawer = document.querySelector('cart-drawer');
      const res = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +btn.dataset.nbUpsell, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname }),
      });
      const json = await res.json();
      if (drawer && json.sections) drawer.renderContents(json);
      else location.href = window.routes?.cart_url || '/cart';
    } catch (err) { console.error(err); }
    btn.removeAttribute('aria-busy');
  });

  /* ---------- Boot + theme editor support ---------- */
  function init(root = document) {
    initReveal(root); initCountdowns(root); initAccordions(root); initRotators(root); initReviews(root);
    initBA(root); initStories(root); initAutoVideos(root); initGallery(root); initProduct(root);
    watchDrawer();
  }
  window.NB = Object.assign(window.NB || {}, { init, formatMoney });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('[data-nb-slide]');
    if (slide) { const w = slide.closest('[data-nb-rotator]'); const k = $$('[data-nb-slide]', w).indexOf(slide); $$('[data-nb-dot]', w)[k]?.click(); slide.classList.add('is-active'); }
    if (e.target.matches('details')) e.target.open = true;
  });
})();
